import React from 'react';

export const ReportContext = React.createContext({
  report: {},
  setReport: () => { },
});
